import React from 'react';

export interface CountryCode {
  code: string;
  country: string;
  dialCode: string;
  flag: string;
}

export const countryCodes: CountryCode[] = [
  { code: 'US', country: 'United States', dialCode: '+1', flag: '🇺🇸' },
  { code: 'CA', country: 'Canada', dialCode: '+1', flag: '🇨🇦' },
  { code: 'GB', country: 'United Kingdom', dialCode: '+44', flag: '🇬🇧' },
  { code: 'AU', country: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', country: 'New Zealand', dialCode: '+64', flag: '🇳🇿' },
  { code: 'MX', country: 'Mexico', dialCode: '+52', flag: '🇲🇽' },
  { code: 'DE', country: 'Germany', dialCode: '+49', flag: '🇩🇪' },
  { code: 'FR', country: 'France', dialCode: '+33', flag: '🇫🇷' },
  { code: 'ES', country: 'Spain', dialCode: '+34', flag: '🇪🇸' },
  { code: 'IT', country: 'Italy', dialCode: '+39', flag: '🇮🇹' },
  { code: 'NL', country: 'Netherlands', dialCode: '+31', flag: '🇳🇱' },
  { code: 'BE', country: 'Belgium', dialCode: '+32', flag: '🇧🇪' },
  { code: 'CH', country: 'Switzerland', dialCode: '+41', flag: '🇨🇭' },
  { code: 'AT', country: 'Austria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'SE', country: 'Sweden', dialCode: '+46', flag: '🇸🇪' },
  { code: 'NO', country: 'Norway', dialCode: '+47', flag: '🇳🇴' },
  { code: 'DK', country: 'Denmark', dialCode: '+45', flag: '🇩🇰' },
  { code: 'FI', country: 'Finland', dialCode: '+358', flag: '🇫🇮' },
  { code: 'IE', country: 'Ireland', dialCode: '+353', flag: '🇮🇪' },
  { code: 'PT', country: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'GR', country: 'Greece', dialCode: '+30', flag: '🇬🇷' },
  { code: 'PL', country: 'Poland', dialCode: '+48', flag: '🇵🇱' },
  { code: 'CZ', country: 'Czech Republic', dialCode: '+420', flag: '🇨🇿' },
  { code: 'JP', country: 'Japan', dialCode: '+81', flag: '🇯🇵' },
  { code: 'CN', country: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'KR', country: 'South Korea', dialCode: '+82', flag: '🇰🇷' },
  { code: 'IN', country: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'SG', country: 'Singapore', dialCode: '+65', flag: '🇸🇬' },
  { code: 'MY', country: 'Malaysia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'TH', country: 'Thailand', dialCode: '+66', flag: '🇹🇭' },
  { code: 'PH', country: 'Philippines', dialCode: '+63', flag: '🇵🇭' },
  { code: 'ID', country: 'Indonesia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'VN', country: 'Vietnam', dialCode: '+84', flag: '🇻🇳' },
  { code: 'IL', country: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { code: 'AE', country: 'UAE', dialCode: '+971', flag: '🇦🇪' },
  { code: 'SA', country: 'Saudi Arabia', dialCode: '+966', flag: '🇸🇦' },
  { code: 'ZA', country: 'South Africa', dialCode: '+27', flag: '🇿🇦' },
  { code: 'BR', country: 'Brazil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'AR', country: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'CL', country: 'Chile', dialCode: '+56', flag: '🇨🇱' },
];

interface CountryCodeSelectorProps {
  value: string;
  onChange: (dialCode: string) => void;
  className?: string;
}

const CountryCodeSelector: React.FC<CountryCodeSelectorProps> = ({
  value,
  onChange,
  className = ''
}) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`border border-gray-300 rounded-l-lg py-3 pl-3 pr-2 bg-gray-50 text-sm font-medium focus:ring-2 focus:ring-ctc-blue focus:border-transparent transition-colors ${className}`}
      style={{ minWidth: '90px' }}
    >
      {countryCodes.map((country) => (
        <option key={country.code} value={country.dialCode}>
          {country.flag} {country.dialCode}
        </option>
      ))}
    </select>
  );
};

export default CountryCodeSelector;
